import React, { useState,useEffect } from "react";
import { useAuth } from "../../../context/authContext"
import { useNavigate } from "react-router-dom";
import { Profile } from "../../../assets/Home";
import { BsCart3 } from "react-icons/bs";
import { MdMiscellaneousServices, MdOutlineFavoriteBorder } from "react-icons/md";
import { RiBox3Line } from "react-icons/ri";
import ChangePasswordModal from "../../../modal/changePassword"
import ConfirmLogoutModal from "../../../modal/confirmLogoutModel";
import { FiLogOut, FiMapPin } from "react-icons/fi";
import { TbPasswordUser } from "react-icons/tb";
import { fetchLoggedUser } from "../../../redux/actions/loggedUserActions";
import { useDispatch, useSelector } from "react-redux";
import UpdateCustomerModal from "../../../modal/updateProfileModel";

const SectionOne = () => {
  const navigate = useNavigate();
  const dispatch=useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [isCancelModalOpen, setCancelModalOpen] = useState(false);

  const { user, error } = useSelector(
    (state) => state.loggedUserState
  );

  useEffect(() => {
    const fetchData = async () => {
           dispatch(fetchLoggedUser());  
    };
    fetchData();
  }, [dispatch]);

  const data=[
    {title:"Your Cart",icon: BsCart3,path:"/cartpage"},
    {title:"Wishlist",icon: MdOutlineFavoriteBorder,path:"/wishlistpage"},
    {title:"Orders",icon: RiBox3Line, path:"/orderpage"},
    {title:"Booked Services",icon: MdMiscellaneousServices, path:"/bookedservices"},
  ]

  const tabdata=[
    {title:"Manage Address",path:"/manageaddress",icon: FiMapPin,},
    {title:"Change Password",icon: TbPasswordUser,},
    {title:"Logout",icon: FiLogOut,}
  ]

{error && (
  <p className="text-red-600">
    {typeof error === "string" ? error : error.message || "Something went wrong"}
  </p>
)}

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h2 className="text-2xl font-semibold text-red-600">Access Denied</h2>
        <p className="mt-2 text-gray-600">You must be logged in to view this page.</p>
        <button
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          onClick={() => navigate("/login")}
        >
          Go to Login
        </button>
        
      </div>
    );
  }

  return (
   <section className="py-8 px-4 md:px-8 xl:px-10">
    <div className="flex flex-col space-y-5">
      <div className="flex flex-col md:flex-row gap-4 justify-between md:items-start">     
        <div className="flex flex-row space-x-4">
            {user.profile? (
              <img src={user.profile} alt="profile" className="w-10 h-10 md:h-12 md:w-12 xl:w-16 xl:h-16"/>
            ) : <img src={Profile} alt="profile" className="w-10 h-10 md:h-12 md:w-12 xl:w-16 xl:h-16"/>}
            
            <div className="flex flex-col justify-between font-medium">
                <p className="text-sm md:text-base xl:text-lg">{user.name} </p>
                <div className="flex flex-col md:flex-row">
                    <p className="text-xs md:text-sm xl:text-base pr-3 md:pr-4 md:border-r-2 border-black">
                      +91 {user.mobileNumber}</p>
                    <p className="text-xs md:text-sm xl:text-base md:pl-4">{user.email}</p>
                </div>
            </div>
        </div>   

        <div className="flex justify-end">
          <button
            onClick={() => setOpenModal(true)}
            className="bg-[#A63F40] hover:bg-[#571819] text-white px-3 py-1 rounded-md text-xs md:text-sm xl:text-base"
          >
            Edit Profile
          </button>
        </div>
        
      </div> 

      <hr className="border-b border-zinc-800"/>    
        <div className="flex flex-row space-x-2 md:space-x-5">
           {data.map((row,idx)=>(
            <div className=" flex flex-col mt-5 md:mt-8 items-center justify-center p-2 md:p-4 xl:p-5 rounded-lg bg-pink-100 w-20 md:w-36 xl:w-48"
            onClick={()=>navigate(row.path)}>
                <row.icon className="text-2xl md:text-2xl xl:text-3xl "/>
                <p className="text-xs md:text-base xl:text-lg text-center">{row.title}</p>
            </div>
           ))}
        </div>
        <div className="grid grid-cols-3 xl:grid-cols-4 gap-x-3 md:gap-x-5 mt-10">
            {tabdata.map((row,idx)=>(
                <div className="flex flex-row space-x-2 items-center border border-gray-700 shadow-md p-2 rounded-md mt-5 md:mt-8 xl:mt-10 " key={idx} 
                onClick={() => {
                  if (row.title === "Change Password") {
                   setIsChangePasswordOpen(true);  
                  }  else if (row.title === "Logout") {
                    setCancelModalOpen(true);
                  } else {
                    navigate(row.path);
                  }
                }}
                >
                    <row.icon className="text-lg md:text-xl xl:text-2xl "/>
                    <p className="text-xs md:text-sm xl:text-base font-medium">{row.title}</p>
                </div>
            ))}
        </div>
    </div>
    <ChangePasswordModal
      isOpen={isChangePasswordOpen}
      onClose={() => setIsChangePasswordOpen(false)}
    />
    
    <ConfirmLogoutModal
      isOpen={isCancelModalOpen}
      onClose={() => setCancelModalOpen(false)}
    />

    <UpdateCustomerModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        userId={user.id}
    />

   </section>
  );
};

export default SectionOne;
